module.exports =  {
  IN: 'INR',
  LK: 'LKR',
  BG: 'BDT'
}
